import React, { useState, useEffect } from "react";
import { collection, getDocs, getFirestore, updateDoc, doc } from "firebase/firestore";
import { app } from '../../credenciales';
import style from "./ListadoAlumnos.module.css";
import UserFormModal from "../../components/Modals/UserFormModal";
import { Button, Container, Form, Table } from "react-bootstrap";
import { FaPlus } from "react-icons/fa6";

const ListadoAlumnos = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);

  const getUsers = async () => {
    const db = getFirestore(app);
    const usuariosCollection = collection(db, "usuarios");

    try {
      const responseDb = await getDocs(usuariosCollection);
      const usersList = responseDb.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsuarios(usersList);
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
    }
  };

  const handleSwitchChange = async (usuarioId, estadoActual) => {
    const db = getFirestore(app);
    const userRef = doc(db, "usuarios", usuarioId);
    await updateDoc(userRef, { estado: !estadoActual });

    setUsuarios((prevUsuarios) =>
      prevUsuarios.map((usuario) =>
        usuario.id === usuarioId ? { ...usuario, estado: !estadoActual } : usuario
      )
    );
  };

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    getUsers();
  }, [usuarios]);

  const handleShowAddModal = () => {
    setShowAddModal(true);
  };

  const handleCloseAddModal = () => setShowAddModal(false);

  // Filtrar usuarios según búsqueda (nombre, apellido, correo o número de socio)
  const usuariosFiltrados = usuarios.filter((usuario) => {
    const termino = busqueda.toLowerCase();
    return (
      usuario.name.toLowerCase().includes(termino) ||
      usuario.lastName.toLowerCase().includes(termino) ||
      usuario.email.toLowerCase().includes(termino) ||
      (usuario.numeroSocio && usuario.numeroSocio.toString().toLowerCase().includes(termino))
    );
  });

  return (
    <Container className="py-4">
     <div className="d-flex justify-content-between align-items-center mb-4"> 
      <h1 className="titles">Lista de alumnos</h1>

      <Button variant="dark" className={`${style.addActivityBtn} d-flex align-items-center primaryBtn`} onClick={handleShowAddModal}>
          <FaPlus size="1.2rem" /> Agregar usuario
        </Button>
</div>
      {/* Input de búsqueda */}
      <Form.Control
        type="text"
        placeholder="Buscar por nombre, apellido, correo o número de socio"
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        className="mb-4"
      />

      {usuarios.length > 0 ? (
        <Table striped bordered hover responsive>
          <thead className="table-dark">
            <tr>
              <th className="text-center">Nombre</th>
              <th className="text-center">Apellido</th>
              <th className="text-center">Correo electrónico</th>
              <th className="text-center">Rol</th>
              <th className="text-center">Número de socio</th>
              <th className="text-center">Fecha de Nacimiento</th>
              <th className="text-center">Estado</th>
            </tr>
          </thead>
          <tbody>
            {usuariosFiltrados.map((usuario) => (
              <tr key={usuario.id}>
                <td>{usuario.name}</td>
                <td>{usuario.lastName}</td>
                <td>{usuario.email}</td>
                <td>
                  {{
                    1: 'Admin',
                    2: 'Alumno',
                    3: 'Profesor'
                  }[usuario.role]}
                </td>
                <td>{usuario.numeroSocio || "N/A"}</td>
                <td>{usuario.fechaNacimiento}</td>
                <td className="text-center">
                  <Form.Check
                    type="switch"
                    id={`switch-${usuario.id}`}
                    label={usuario.estado ? "✅ Pagado" : "❌ No Pagado"}
                    checked={usuario.estado === true}
                    onChange={() => handleSwitchChange(usuario.id, usuario.estado)}
                    className={style.userPaySwitch}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p>Cargando usuarios...</p>
      )}
      <UserFormModal showModal={showAddModal} handleCloseModal={handleCloseAddModal} isModal={true} edit={false} />
    </Container>
  );
};

export default ListadoAlumnos;
